angular.module('impactx.MenuDirectives').directive('ixMessageInfo', function () {
    return {
        restrict: 'A',
        templateUrl: 'shared/menu/templates/messageinfo-menu.tmpl.html'
    }
});